import { render } from "./RegisterUserSuccessful.vue?vue&type=template&id=50dc96a0"
import script from "./RegisterUserSuccessful.vue?vue&type=script&lang=js"
export * from "./RegisterUserSuccessful.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__